import { render, staticRenderFns } from "./commission-agent.vue?vue&type=template&id=771f8a54&scoped=true"
import script from "./commission-agent.vue?vue&type=script&lang=js"
export * from "./commission-agent.vue?vue&type=script&lang=js"
import style0 from "./commission-agent.vue?vue&type=style&index=0&id=771f8a54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f8a54",
  null
  
)

export default component.exports